const activationDialogConstantsEn = {
  userDeactivation: 'Deactivate SBA user',
  userActivation: 'Activate SBA user',
  userDeactivationContent:
    'You are trying to deactivate this user in the sayma admin pane! Login access to sayma admin panel  will be denied for this user, Are you sure you still want to do this action?',
  userActivationContent: 'You are trying to activate this user in the sayma admin pane! Are you sure?',
  deactivatePrompt: 'Yes, Deactivate',
  activatePrompt: 'Yes, Activate',
  cancel: 'Cancel',
};

export default activationDialogConstantsEn;
